export default "__VITE_ASSET__DV7aNkJB__"